export const { colors, textColors } = require('./colors');
export const safelist = require('./safelist');
export const spacings = require('./spacings');
